import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const EndUseDetails = ({ endUseDetailsList }) => {

    const endUseDetailsColumns = [
      {
        field: "endUseCode",
        headerName: "End Use Code",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "summaryEndUseId",
        headerName: "Summary End Use ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "endUseDesc",
        headerName: "End Use Description",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "assessedRole",
        headerName: "Assessed Role",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "usageOfLoanCode",
        headerName: "Usage Of Loan Code",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "usageOfLoanDesc",
        headerName: "Usage Of Loan Description",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "modifiedBy",
        headerName: "Modified By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.createdDate),
      },
      {
        field: "modifiedDate",
        headerName: "Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.modifiedDate),
      },
    ];

        return(
            <AccordianContainer
            id="accord"
            title="End Use Details"
            initialOpen={false}
          >
            <Box sx={{ marginTop: "-0.5%" }}>
            <CustomDataGrid
              noDataMessage="No Data"
              rows={ validate(endUseDetailsList) ?
                endUseDetailsList.map((item, index) => ({
                  id: index + 1,
                  ...item,
                })) : []}
              columns={endUseDetailsColumns}
              pageSize={15}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              gridHeight={305}
              getRowId={(row) => row.endUseCode}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
            />
            </Box>
            </AccordianContainer>
        );

}

export default EndUseDetails;